import { TagPillOverflow, type TagPillGroup } from 'src/features/tags/TagPill';
import { ResourceTag } from '../types';

export default function ActionTagPills({
  tags,
  maxVisible = 2,
  maxWidth
}: {
  tags?: ResourceTag[] | null;
  maxVisible?: number;
  maxWidth?: number | string;
}) {
  const visible = (tags ?? []).filter((t) => t.status !== 'rejected');
  if (visible.length === 0) {
    return <span className="text-xs italic text-content-subtlest">No tags</span>;
  }
  const overflowItems = visible.map((tag) => {
    return {
      key: tag.id,
      group: tag.group as TagPillGroup,
      label: tag.label,
      confirmed: tag.status === 'approved',
      title:
        tag.origin === 'inherited'
          ? 'Inherited from source document'
          : tag.status === 'suggested'
            ? 'AI-suggested'
            : tag.confidence != null
              ? `Confidence ${tag.confidence}`
              : undefined
    };
  });
  return <TagPillOverflow maxVisible={maxVisible} maxWidth={maxWidth} items={overflowItems} />;
}
